import fastDeepEqual from "fast-deep-equal";

export default function deepEqual(a, b): boolean {
  return a === b || fastDeepEqual(a, b);
}
